import ogiriImageSource from "../assets/oogiri-introduction-16x7-v1.jpg";
import { FeatureIntroductionSlide } from "./FeatureIntroductionSlide";

export const OGIRI_IMAGE_SOURCE = ogiriImageSource;
export const OGIRI_IMAGE_WIDTH = 1934;
export const OGIRI_IMAGE_HEIGHT = 846;

export function OgiriSlide() {
  return (
    <FeatureIntroductionSlide
      slideId="ogiri"
      number="03"
      title="企画紹介（大喜利）"
      imageSource={OGIRI_IMAGE_SOURCE}
      imageWidth={OGIRI_IMAGE_WIDTH}
      imageHeight={OGIRI_IMAGE_HEIGHT}
      imageAlt="マイクと座布団、回答札が並ぶ大喜利の舞台"
    />
  );
}
